import { Box, Typography } from '@mui/material';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/seoSegmentationListingPage';
import { useResponsive } from '@/components/hooks/useResponsive';
import { CaregiverBadges } from './CaregiverBadges';

interface CaregiverHeaderProps {
  displayName: Caregiver['member']['displayName'];
  isPremium: Caregiver['member']['isPremium'];
  hasCareCheck: Caregiver['hasCareCheck'];
}

export const CaregiverHeader = ({ displayName, isPremium, hasCareCheck }: CaregiverHeaderProps) => {
  const { isSmallViewport } = useResponsive();

  return (
    <Box display="flex" alignItems="center" justifyContent="start">
      <Typography mr={1} display="inline-flex" variant={isSmallViewport ? 'h3' : 'h2'}>
        {displayName}
      </Typography>
      <CaregiverBadges isPremium={isPremium} hasCareCheck={hasCareCheck} />
    </Box>
  );
};
